import clsx from 'clsx';

import { Icon, NavLink } from '../../components';
import type { ContactItemType } from '../hooks';

type ContactNameProps = {
  contact: ContactItemType;
  withMessagesLink?: boolean;
};

const ContactName: React.FC<ContactNameProps> = ({
  contact,
  withMessagesLink,
}) => {
  const { id, email, phone } = contact;
  const { requires_human_input, first_name, last_name } = contact;

  const nameElement = (
    <>
      {!!requires_human_input && (
        <Icon
          icon="required"
          iconStyle="danger"
          className="mr-sm"
          tooltip="Requires human input"
        />
      )}
      <div
        className={clsx(
          'truncate',
          requires_human_input && 'text-danger text-medium font-bold'
        )}
      >
        {[first_name || '', last_name || ''].filter(Boolean).join(' ')}
      </div>
    </>
  );

  return (
    <div>
      {withMessagesLink ? (
        <NavLink
          to={`/messages_history/${id}`}
          className="flex flex-row items-center text-text"
        >
          {nameElement}
          <Icon
            icon="link"
            tooltip="View messages"
            className="ml-sm shrink-0"
          />
        </NavLink>
      ) : (
        <div className="flex flex-row items-center text-text">
          {nameElement}
        </div>
      )}
      <div className="text-tiny text-textLight">{email}</div>
      <div className="text-tiny text-textLight">{phone}</div>
    </div>
  );
};

export default ContactName;
